import React from 'react'
import './education.css'

const Education = () => {
  return (
    <div id='Education' className='education'>
      <h1 className='heading'>EDUCATION QUALIFICATION</h1>
      <table className='table'>
        <th>Year</th>
        <th>Degree</th>
        <th>School/Institution</th>
        <th>Board/University</th>
        <th>%age/CGPA</th>
          <tr>
            <td>2024</td>
            <td>B.Tech</td>
            <td>Chandigarh Engineering College, Landran</td>
            <td>Ik Gujral Punjab Technical University, Kapurthala</td>
            <td>8.08 CGPA</td>
          </tr>
          <tr>
            <td>2020</td>
            <td>10+2</td>
            <td>DAV Public Sen. Sec. School, Rupnagar</td>
            <td>Punjab School Education Board</td>
            <td>88.4 %</td>
          </tr>
          <tr>
            <td>2017</td>
            <td>Matriculation</td>
            <td>Shiwalik Public School, Rupnagar</td>
            <td>Central Board of Secondary Education</td>
            <td>8.2 CGPA</td>
          </tr>
      </table>
    </div>
  )
}

export default Education
